import restClient from "../restClient";

const endpoint = "enum-inventory-options";

export const getEquipmentOptions = async () => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get(endpoint, config);
    return response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const createEquipmentOption = async (data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.post(endpoint, { data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const updateEquipmentOption = async (id, data) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.put(`${endpoint}/${id}`, { data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const deleteEquipmentOption = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.delete(`${endpoint}/${id}`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
}; 